module.exports = __webpack_public_path__ + "static/img/1_0_1.6ce346a9.jpg";